module.exports = "/_next/static/images/d309211178a2f23b4621035c538af799-2-women-working-landscape@0.75x.jpg.webp";